import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ed77cfe"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["xlink:href", "fill"]

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SvgContainer',
  props: {
  // 图标名称（对应 SVG 文件名，不含扩展名）
  name: {
    type: String,
    required: true
  },
  // 图标颜色，默认继承父元素的 color
  fill: {
    type: String,
    default: '#64748B'
  },
  // 图标大小，可以是数字（px）或字符串（如 '1.5em'）
  size: {
    type: [Number, String],
    default: 24
  },
  // 自定义前缀（如果插件配置了 prefix 选项）
  prefix: {
    type: String,
    default: 'sprite-' // 与插件默认 prefix 保持一致
  }
},
  setup(__props) {

const props = __props;

// 计算图标在雪碧图中的完整 ID
const iconName = computed(() => {
  return `#${props.prefix}${props.name}`;
});

// 计算 SVG 样式
const svgStyle = computed(() => {
  const sizeValue = typeof props.size === 'number' ? `${props.size}px` : props.size;
  return {
    width: sizeValue,
    height: sizeValue
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    class: "svg-icon",
    style: _normalizeStyle(svgStyle.value),
    "aria-hidden": "true"
  }, [
    _createElementVNode("use", {
      "xlink:href": `/svg/spritemap.svg${iconName.value}`,
      fill: __props.fill
    }, null, 8, _hoisted_1)
  ], 4))
}
}

})